<template>
	<div>
        <h2>Appel à ChatGPT</h2>

		<p><b>Données initiales</b></p>

		<b-select v-model="type_data_test" :options="[
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<br /><br />

		<div v-if="type_data_test == 'tabulator'">
			<edit_tabulator @update="import_file" ref="tabulator"></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
			@update="import_file"
			_type="db"
			:minimal="true"
			ref="tabulator" />

		<div v-if="type_data_test == 'database'">
			<database
				@update="import_file"
				:change_table="true"
				:name="false"
				:edit="false"
				ref="tabulator"></database>
		</div>

		<b>Options</b>

		<br />

		<div>
			<p>
				Modèle <b-select style="display: inline-block; width:100px" :options="['liste', 'libre']" v-model="type_model"></b-select>
			</p>
			
			<b-select v-if="type_model == 'liste'" :options="chatgpt_train" v-model="options.chatgpt_train"></b-select>

			<div v-if="type_model == 'libre'">
				<b-textarea rows="5" v-model="options.chatgpt_train"></b-textarea>
				<b-button variant="link" v-b-toggle="'collapse-list'">Voir la liste des modèles</b-button>
				<b-collapse id="collapse-list">
					<div v-for="model in chatgpt_train" :key="model">
						{{model}}
					</div> 
				</b-collapse>
			</div>

		</div>

		<br />

		<p>Colonne de résultats
			<b-input v-model="column_result" />
		</p>

		<p>Type
			<b-select  
				v-model="type"
				:options="[
					{ value: 'content', text: 'Texte' },
					{ value: 'messages', text: 'Messages' },
				]"></b-select>
		</p>

		<div v-if="type == 'content'">
			<p>
				Texte
				<b-textarea rows="5" v-model="options.input"></b-textarea>
			</p>
		</div>
		<div v-else>
			<draggable
				handle=".handle"
				:list="options.messages"
				:group="{ name: 'g1' }">
					<div v-for="(message, idx) in options.messages" :key="idx">
						<p>
							Rôle
							<b-select v-model="message.role" :options="[
								{ value: 'system', text: 'Système' },
								{ value: 'assistant', text: 'Assistant' },
								{ value: 'user', text: 'Utilisateur' },
							]"></b-select>
							<span v-show="message.role == 'user'">
								Type
								<b-select v-model="message.type" :options="[{ value: 'text', text: 'Texte' }, { value: 'image', text: 'Image' }]" />
								<span v-show="message.type == 'image'">Image</span>
								<span v-show="message.type == 'text' || !message.type">Texte</span>
							</span>
							<br /><br />
							<b-textarea rows="5" v-model="message.content"></b-textarea>
						</p>
						<b-button variant="link" @click="removeMessage(idx)"><i class="fas fa-trash"></i></b-button>
						<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
					</div>
				</draggable>
			<br />
			<b-button @click="addMessage"><i class="fas fa-plus"></i></b-button>
			<br /><br />
		</div>

		<b-button @click="test">Test</b-button>

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>

		<p><b>Résultats</b></p>

		<div v-if="error">
			Erreur : {{ error }}
		</div>

		<b-textarea rows="15" v-model="results"></b-textarea>

		<div v-if="request">
			<p>Requête envoyée à ChatGPT
				<b-textarea rows="10" v-model="request.messages"></b-textarea>
			</p>
			<p>Modèle : {{request.model}}</p>
		</div>

		<br />
		<b-button @click="test_file">Test sur l'ensemble des données</b-button>

		<b-checkbox v-model="column_request">Récupérer la requête</b-checkbox>

		<b-tabs>
			<b-tab title="Tableau">
				<edit_tabulator
					ref="result_tabulator"
					@update="import_test_file"
				>
				</edit_tabulator>
			</b-tab>
			<b-tab title="Visualisation">
				<div v-if="test_idx > -1">
					<p><b-button variant="link" @click="test_idx--" v-if="test_idx > 0">&lt;</b-button>{{test_idx + 1}} / {{test_data_file.length}}<b-button variant="link" @click="test_idx++" v-if="test_idx + 1 < test_data_file.length">&gt;</b-button></p>
					<div v-if="test_data_file[test_idx].request">
						<p>Requête</p>
						<pre style="white-space:pre-wrap; word-wrap:break-word;">{{ JSON.stringify(JSON.parse(test_data_file[test_idx].request), "", 4) }}</pre>
					</div>
					<p>Résultats</p>
					<b-container style="margin: 0; padding: 0; max-width: none">
						<b-row style="margin-bottom:10px">
							<b-col cols="6">
								<b-textarea style="height:100%;" v-model="test_data_file[test_idx].result"></b-textarea>
							</b-col>
							<b-col>
	                            <div v-html="test_data_file[test_idx].result ? test_data_file[test_idx].result.replace(/\n/g, '<br />') : ''"></div>
							</b-col>
						</b-row>
					</b-container>
					<p>Ligne</p>
					<pre>{{test_data_file[test_idx]}}</pre>
				</div>
			</b-tab>
		</b-tabs>

		<div v-if="spinner_file">
			<div class="center_spinner">
				<fade-loader></fade-loader>
			</div>
			<b-button v-if="!stop_file" @click="stop_file = true" variant="danger">Arrêter le test</b-button>
		</div>

	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import library from "../services/library.js";
	import workers from "../services/workers.js";
    import database from "../services/database.js";
	import projects from "../services/projects.js";
	import databaseView from "../views/database.vue";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import c_treatment_params from "../components/params.vue"
	import edit_tabulator from "../components/edit_tabulator.vue";
    import DatabaseRequestView from '../views/DatabaseRequestView.vue';

	var clone = require("clone");

	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	export default {
		name: "chatgpt",
		components: {
			edit_tabulator,
			database: databaseView,
			DatabaseRequestView,
			c_treatment_params,
			FadeLoader,
			draggable
		},
		props: {
		},
		data() {
			return {
                id: uniqueId(""),
                				
				options: {
					type: "gpt-3.5-turbo",
					input: "",
					messages: [],
					chatgpt_train: "",
					model: ""
				},

				type_data_test: "tabulator",
				spinner: false,
				spinner_file: false,
				stop_file: false,
				test_data: [],
				test_data_file: [],
				test_idx: -1,

				input: "",
				results: "",
				request: null,
				error: "",

				type: "content",

				chatgpt_train: [],
				column_request: true,
				type_model: 'liste',

				column_result: "result"
			};
		},
		watch: {
		},
		methods: {
			removeMessage(idx)
			{
				this.options.messages.splice(idx, 1);
			},
			addMessage()
			{
				this.options.messages.push({
					role: "user",
					content: "",
					type: "text"
				})
			},
			import_file()
			{
				console.log("import_file")
				this.test_data = this.$refs.tabulator.get_data();
			},
			import_test_file()
			{
				this.test_data_file = this.$refs.result_tabulator.get_data();
				if (this.test_idx == -1 && this.test_data_file.length > 1)
					this.test_idx = 0;
				if (this.test_idx > this.test_data_file.length)
					this.test_idx = 0;
			},
			async test_file()
			{
				this.error = "";
				this.spinner_file = true;

				this.test_data = await this.$refs.tabulator.get_data();
				this.$refs.result_tabulator.load([]);
				this.test_data_file = [];
				this.test_idx = -1;

				for (var i = 0; i < this.test_data.length && !this.stop_file; i++)
				{
					var parameters = {					
						return_line: "<br />",
						chatgpt_train: this.options.chatgpt_train,
						model: this.options.model,
						"type": this.type,
						"column_result": this.column_result,
						"column_error": "error"
					}

					if (this.column_request)
						parameters.column_request = "request";

					if (this.type == "content")
					{
						parameters.content = this.options.input;
					}
					else
					{
						parameters.messages = this.options.messages;
					}

					var formData = new FormData();
					formData.append("data", JSON.stringify([this.test_data[i]]));
					formData.append("action", "openai");
					formData.append("parameters", JSON.stringify(parameters));

					try
					{
						var data = await workers.test(formData);
					}
					catch (err)
					{
						this.error = err;
						this.spinner = false;
						return;
					}

					console.log(data.data)

					if (data.data.json.length > 0)
					{
						data = data.data.json;

						if (i == 0)
						{
							this.$refs.result_tabulator.load(data);
							this.test_idx = 0;
						}
						else
							this.$refs.result_tabulator.add_data(data);
					}
				}

				this.stop_file = false;
				this.spinner_file = false;
			},
			async test()
			{
				this.error = "";
				this.spinner = true;

				var data = [{
					id: 0
				}];

				this.test_data = await this.$refs.tabulator.get_data();
				if (this.test_data.length > 0)
					data = [this.test_data[0]];

				var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var parameters = {
					return_line: "<br />",
					chatgpt_train: this.options.chatgpt_train,
					model: this.options.model,
					"type": this.type,
					"column_result": this.column_result,
					"column_error": "error",
					"column_request": "request"
				}

				if (this.type == "content")
				{
					parameters.content = this.options.input;
				}
				else
				{
					parameters.messages = this.options.messages;
				}

				var formData = new FormData();
				formData.append(files[0].name, files[0]);
				formData.append("action", "openai");
				formData.append("parameters", JSON.stringify(parameters));

				try
				{
					var data = await workers.test(formData);
				}
				catch (err)
				{
					this.error = err;
					this.spinner = false;
					return;
				}

				if (data.data.files.length > 0)
				{
					var csv_data = await treatments.getFileAlyx(
						data.data.files[0].url,
						false,
						false
					);
					var data  = this.$papa.parse(csv_data, {
						header: true,
					});
					data = data.data;

					this.results = data[0][this.column_result] || "";
					this.request = data[0].request || "{}"
					this.request = JSON.parse(this.request)
					this.request.messages = JSON.stringify(this.request.messages, "", 4)
					if (this.results)
						this.results = this.results.replace(/<br \/>/g, "\n");

					if (data[0].error)
						this.error = data[0].error;
				}

				this.spinner = false;
			},
			async load(data)
			{
				console.log(data);

				var self = this;

				if (data.type_data_test)
					this.type_data_test = data.type_data_test;
				else
					this.type_data_test = "tabulator"

				if (data.options)
					this.options = data.options;

				if (data.type)
					this.type = data.type;

				this.type_model = "liste";
				if (data.type_model)
					this.type_model = data.type_model;

				if (data.column_result)
					this.column_result = data.column_result;

                self.$nextTick(async function () {
					if (data.test_data)
					{
						self.$refs.tabulator.load(data.test_data);
					}
				});
			},
			async load_data(data)
			{
				var self = this;
				this.type_data_test = "tabulator"

				self.$nextTick(async function () {
					self.$refs.tabulator.load(data);
				});
			},
			async save()
			{
				var data = null;
				
				data = await this.$refs.tabulator.save();
				
				if (this.type_data_test == "tabulator")
					data = data.slice(0, 10);

				return {
					type_data_test: this.type_data_test,
					options: this.options,
					test_data: data,
					type: this.type,
					type_model: this.type_model,
					column_result: this.column_result
				}
			},
		},
		mounted: async function () {
			var names = await library.getby_production("chatgpt_train");
			names = names.element;

			this.chatgpt_train = [""];
			for (var i = 0; i < names.length; i++) {
				this.chatgpt_train.push(names[i].name);
			}
		},
	};
</script>

<style>
.center_spinner {
	width: 0%;
	margin: 0 auto;
	margin-top: 30px;
}
</style>
